export default {"src":"/_next/static/media/wifi.872178cd.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};